<app-loading-wrapper [loading]="loading">
    <div *ngFor="let instructor of instructors">
        <ul>
            <li>{{instructor.firstName}} {{instructor.lastName}}
                <span *ngIf="instructor.bannerId"> [{{instructor.bannerId}}]</span>
                <span *ngIf="instructor.netId"> ({{instructor.netId}})</span>
                <ul>
                    <li *ngIf="instructor.role">Instructor Role: {{instructor.role}}</li>
                    <li *ngIf="instructor?.rank?.code">Rank: {{instructor?.rank?.description}} [{{instructor?.rank?.code}}]</li>
                    <li *ngIf="instructor?.staffType?.code">Staff Type: {{instructor?.staffType?.description}} [{{instructor?.staffType?.code}}]</li>
                </ul>
            </li>
        </ul>

    </div>
    <app-button-list>
        <app-button [loading]="loading"
                    [toolTip]="'Bypass Cached Data and Refresh Instructors'"
                    (clickedEvent)="refreshInstructors()">Refresh Instructors</app-button>
    </app-button-list>
</app-loading-wrapper>
